export default __webpack_public_path__ + "static/media/more-campaign-arrow.3ab9ddb4.svg";